import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Paper, Stack, Typography, TextField, MenuItem, Chip,
  Table, TableBody, TableCell, TableHead, TableRow, IconButton,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Swal from "sweetalert2";
import { listarRecursos } from "../../services/recursoService";
import { fmtData as fmtDataSegura } from "../../utils/data";

const fmt = (d) => fmtDataSegura(d, "—");
const chip = (s) =>
  s === "D" ? <Chip size="small" label="Deferido" color="success" />
  : s === "I" ? <Chip size="small" label="Indeferido" color="error" />
  : <Chip size="small" label="Pendente" color="warning" />;

export default function RecursoList() {
  const navigate = useNavigate();
  const [recursos, setRecursos] = useState([]);
  const [status, setStatus] = useState("");

  const carregar = async (st) => {
    try { setRecursos((await listarRecursos(st)).data); }
    catch (e) { Swal.fire("Erro", e?.response?.data || e.message, "error"); }
  };

  useEffect(() => { carregar(status); }, [status]);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Recursos</Typography>
        <TextField select size="small" label="Situação" value={status}
          onChange={(e) => setStatus(e.target.value)} sx={{ width: 220 }}>
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="P">Pendentes</MenuItem>
          <MenuItem value="D">Deferidos</MenuItem>
          <MenuItem value="I">Indeferidos</MenuItem>
        </TextField>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Ficha</TableCell>
              <TableCell>Edição</TableCell>
              <TableCell>Candidato</TableCell>
              <TableCell>Situação</TableCell>
              <TableCell>Enviado</TableCell>
              <TableCell>Analisado</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {recursos.map((r) => (
              <TableRow key={r.Id} hover>
                <TableCell>{r.Id}</TableCell>
                <TableCell>#{r.IdFicha}</TableCell>
                <TableCell>{r.Edicao}</TableCell>
                <TableCell>{r.Candidato}</TableCell>
                <TableCell>{chip(r.Status)}</TableCell>
                <TableCell>{fmt(r.DtCadastro)}</TableCell>
                <TableCell>{fmt(r.DtAnalise)}</TableCell>
                <TableCell align="center">
                  <IconButton size="small" title="Avaliar" onClick={() => navigate(`/recursos/${r.Id}`)}>
                    <VisibilityIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {recursos.length === 0 && (
              <TableRow><TableCell colSpan={8} align="center">Nenhum recurso encontrado.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
